import { Skeleton } from "@mui/material";

import styles from "./SkeletonCell.module.css";

/**
 * Cell content for a placeholder (`__skeleton`) row.
 */
export function SkeletonCell() {
  return <Skeleton variant="rounded" animation="wave" className={styles.bar} />;
}
